import React from 'react'

const CheckBoxErrorText = ({ textVisible }) => {
  return textVisible ? (
    <div
      style={{
        marginTop: '.5rem',
        marginLeft: '0.5rem',
        fontSize: '9px',
        color: 'red',
      }}
    >
      *Bu Alan Zorunludur.
    </div>
  ) : (
    <div
      style={{
        marginTop: '0.1rem',
        marginLeft: '0.5rem',
        fontSize: '9px',
        color: 'red',
      }}
    ></div>
  )
}

export default CheckBoxErrorText
